<script setup lang="ts">
import ToastContainer from '@lib/components/shared/ToastContainer.vue'
import ConfirmDialog from '@lib/components/shared/ConfirmDialog.vue'
import { installSearchShortcut } from '@lib/composables/useSearchShortcut'

installSearchShortcut()
</script>

<template>
    <RouterView />
    <ToastContainer />
    <ConfirmDialog />
</template>
